export const suklPharmaceuticalFormFrag = `
    id
    code
    name
`;
